<div [attr.class]="layout">
  <!-- TODO: Bring back translation once weblate/lexicon is working again -->
  <!--  <span>{{ 'EMAIL_TEMPLATES.PREVIEW.BUSINESS_SELECTOR.BUSINESS_FOR_PREVIEW_LABEL' | translate }}:</span>-->
  <span>Business for preview</span>
  <div class="business">
    <span class="name">{{ name }}</span>
    <ng-container *ngIf="showWarning">
      <mat-icon [glxyTooltip]="warning">warning_filled</mat-icon>
      <!--      <mat-icon [glxyTooltip]="warningKey | translate">warning_filled</mat-icon>-->
    </ng-container>
  </div>
  <button mat-raised-button (click)="openBusinessSelectDialog()">Select another business</button>
</div>
